import config from 'constants/config'
import { getTwinFlashAccommodation, getFlashAccommodationPrice, getFlashPricePerPersonForOption } from './addBundlePriceToTourOffer'

export const BUNDLED_TOUR_ID = 'tour-e8c5e5c1-7eae-430d-91e4-aeb9a670258c'

export default function tourBundleOfferPageStatus(
  tourId: string,
  currency: string,
  offer: App.Tours.TourV2Offer | undefined,
  bundleState: App.StatefulData<App.Tours.Bundle, unknown> | undefined,
): 'loading' | 'ready' | 'error' {
  if (config.APP_ENV === 'production' || tourId !== BUNDLED_TOUR_ID) return 'ready'
  if (offer?.source === 'ttc') return 'ready'
  if (offer && bundleState?.data) {
    if (!getTwinFlashAccommodation(bundleState.data)) return 'error'
  }
  if (currency !== 'AUD') return 'ready'
  if (bundleState?.error) return 'ready'
  if (!bundleState?.data || !offer) return 'loading'
  const bundle = bundleState.data
  const audDepartures = Object.values(offer.departures)
    .filter(departure => !departure.currencyCode || departure.currencyCode === 'AUD')

  return audDepartures.every(departure => {
    const flashPrice = getFlashAccommodationPrice(bundle, departure.startDate)
    return !flashPrice || departure.options.every(option =>
      getFlashPricePerPersonForOption(option, flashPrice.sellPrice, flashPrice.occupancy) === undefined ||
      (option.ltleBundleId === bundle.id && option.bundledPrice !== undefined),
    )
  }) ? 'ready' : 'error'
}
